"use client"

import dynamic from "next/dynamic"
import { Suspense } from "react"

const Footer = dynamic(() => import("./index"), {
  loading: () => null,
  ssr: false
})

/**
 * Code-splits footer chunk, but always mounts on the client.
 * IntersectionObserver gating previously skipped the footer on long pages
 * (homepage especially): the empty sentinel never intersected, so `<footer>`
 * never appeared even after scrolling to the bottom.
 */
export default function LazyFooter() {
  return (
    <Suspense fallback={null}>
      <Footer />
    </Suspense>
  )
}
